import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { ThemeProvider as EmotionThemeProvider } from "@emotion/react";
import { darkTheme } from "src/Theme/darkTheme";
import { QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { queryClient } from "src/Config/queryClient";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { IoProvider } from "socket.io-react-hook";
import { AppModeProvider } from "src/Common/context/AppModeContext";
import { AuthProvider } from "src/Common/context/AuthContext";

const theme = createTheme(darkTheme);

// Bypass login in local dev when VITE_AUTH_DISABLED=true AND the build is
// a Vite dev build. The `import.meta.env.DEV` check guarantees that even if
// VITE_AUTH_DISABLED leaks into a production build (e.g. via .env.local),
// auth is still enforced in production.
export const AUTH_DISABLED =
  import.meta.env.VITE_AUTH_DISABLED === "true" && import.meta.env.DEV;

export const Providers = ({ children }: { children: React.ReactNode }) => (
  <IoProvider>
    <ThemeProvider theme={theme}>
      <EmotionThemeProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <AppModeProvider>
              <ToastContainer />
              {children}
              <ReactQueryDevtools initialIsOpen={false} />
            </AppModeProvider>
          </AuthProvider>
        </QueryClientProvider>
      </EmotionThemeProvider>
    </ThemeProvider>
  </IoProvider>
);
